import { render, staticRenderFns } from "./VerCertificado.vue?vue&type=template&id=fdf731ea&scoped=true"
import script from "./VerCertificado.vue?vue&type=script&lang=js"
export * from "./VerCertificado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf731ea",
  null
  
)

export default component.exports